import { createContext } from 'react'
import { EMPTY_ANNOUNCEMENT, type Announce, type Announcement } from './state'

// Two contexts rather than one holding both: `announce` never changes identity, so the many
// components that only call it are not re-rendered when a message changes. Only the
// Announcer instances subscribe to the announcement itself.
const noAnnouncer: Announce = () => {
  // No AnnouncerProvider above: nothing is listening.
}

export const AnnounceContext = createContext<Announce>(noAnnouncer)
export const AnnouncementContext = createContext<Announcement>(EMPTY_ANNOUNCEMENT)
